module.exports = __webpack_public_path__ + "img/bg4@2x.d1ea22e9.jpg";